import { render, staticRenderFns } from "./Company.container.vue?vue&type=template&id=5bb707e4&scoped=true&"
import script from "./Company.container.vue?vue&type=script&lang=js&"
export * from "./Company.container.vue?vue&type=script&lang=js&"
import style0 from "./Company.container.vue?vue&type=style&index=0&id=5bb707e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb707e4",
  null
  
)

export default component.exports